/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import { SqlVulnerabilityAssessmentBaselines } from "../operationsInterfaces";
import * as coreClient from "@azure/core-client";
import * as Mappers from "../models/mappers";
import * as Parameters from "../models/parameters";
import { SqlManagementClient } from "../sqlManagementClient";
import {
  VulnerabilityAssessmentName,
  BaselineName,
  DatabaseSqlVulnerabilityAssessmentRuleBaselineListInput,
  SqlVulnerabilityAssessmentBaselinesCreateOrUpdateOptionalParams,
  SqlVulnerabilityAssessmentBaselinesCreateOrUpdateResponse
} from "../models";

/** Class containing SqlVulnerabilityAssessmentBaselines operations. */
export class SqlVulnerabilityAssessmentBaselinesImpl
  implements SqlVulnerabilityAssessmentBaselines {
  private readonly client: SqlManagementClient;

  /**
   * Initialize a new instance of the class SqlVulnerabilityAssessmentBaselines class.
   * @param client Reference to the service client
   */
  constructor(client: SqlManagementClient) {
    this.client = client;
  }

  /**
   * Add a database's vulnerability assessment rule baseline list.
   * @param resourceGroupName The name of the resource group that contains the resource. You can obtain
   *                          this value from the Azure Resource Manager API or the portal.
   * @param serverName The name of the server.
   * @param vulnerabilityAssessmentName The name of the vulnerability assessment.
   * @param baselineName
   * @param parameters The requested rule baseline resource.
   * @param options The options parameters.
   */
  createOrUpdate(
    resourceGroupName: string,
    serverName: string,
    vulnerabilityAssessmentName: VulnerabilityAssessmentName,
    baselineName: BaselineName,
    parameters: DatabaseSqlVulnerabilityAssessmentRuleBaselineListInput,
    options?: SqlVulnerabilityAssessmentBaselinesCreateOrUpdateOptionalParams
  ): Promise<SqlVulnerabilityAssessmentBaselinesCreateOrUpdateResponse> {
    return this.client.sendOperationRequest(
      {
        resourceGroupName,
        serverName,
        vulnerabilityAssessmentName,
        baselineName,
        parameters,
        options
      },
      createOrUpdateOperationSpec
    );
  }
}
// Operation Specifications
const serializer = coreClient.createSerializer(Mappers, /* isXml */ false);

const createOrUpdateOperationSpec: coreClient.OperationSpec = {
  path:
    "/subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.Sql/servers/{serverName}/sqlVulnerabilityAssessments/{vulnerabilityAssessmentName}/baselines/{baselineName}",
  httpMethod: "PUT",
  responses: {
    200: {
      bodyMapper: Mappers.DatabaseSqlVulnerabilityAssessmentBaselineSet
    },
    default: {}
  },
  requestBody: Parameters.parameters83,
  queryParameters: [Parameters.apiVersion4, Parameters.systemDatabaseName],
  urlParameters: [
    Parameters.$host,
    Parameters.subscriptionId,
    Parameters.resourceGroupName,
    Parameters.serverName,
    Parameters.vulnerabilityAssessmentName,
    Parameters.baselineName1
  ],
  headerParameters: [Parameters.contentType, Parameters.accept],
  mediaType: "json",
  serializer
};
